import { render } from "./SchoolVue.vue?vue&type=template&id=74981bac&scoped=true"
import script from "./SchoolVue.vue?vue&type=script&lang=js"
export * from "./SchoolVue.vue?vue&type=script&lang=js"

import "./SchoolVue.vue?vue&type=style&index=0&id=74981bac&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74981bac"]])

export default __exports__